import React from 'react'
import { CurvyDividerTop } from './dividers'

function Footer() {
  return (
    <footer className="max-w-[2560px] mx-auto relative pt-32 lg:pt-72 pb-20">
      <CurvyDividerTop />
      <div className="max-w-screen-xl mx-auto px-3 lg:px-0">
        <img
          src="/img/2026-ASBA-Platinum-Partners-Banner.png"
          alt="ASBANSW 2026 Footer Logo"
          className="mx-auto"
        />
        <div className="border-t border-gray-300 py-5 text-center">
            <p className="mb-0">© 2026 <a href="https://icmsaust.com.au/" target="_blank" rel="noopener noreferrer" className="text-c1 hover:text-c1/80">ICMSA</a>. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
